// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__2P_an","disabled":"FileBtn_disabled____cB-","warn":"FileBtn_warn__1D6Os","fade":"FileBtn_fade__2gnSA"};